<h2 mat-dialog-title
  class="mat-typography">{{ information }}</h2>
<div mat-dialog-content
  class="mat-typography">
  <h2>{{ questionConserverResultatPrecedent }}</h2>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
    (click)="dialogRef.close(false)">{{ non }}</button>
  <button mat-raised-button
    color="primary"
    (click)="dialogRef.close(true)">{{ oui }}</button>
</div>
